import { StatusPill, Typography } from '@repo/ui';
import { Badge } from 'components';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { ConditionForKit } from 'types/Conditions';
import {
  conditionEvaluationColor,
  conditionEvaluationIcon,
  conditionEvaluationLabel,
} from '../conditionEvaluation';
import ConditionLinkCard from './ConditionLinkCard';
import styles from './ConditionMarkersSection.module.css';

type ConditionMarkersSectionProps = {
  markers: ConditionForKit[];
};

export default function ConditionMarkersSection({
  markers,
}: ConditionMarkersSectionProps) {
  const { currentKitId } = useCurrentKitAndTinyAccount();

  if (!markers.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.titleRow}>
          <Typography variant='heading-m'>Condition markers</Typography>
          <Badge
            title='Emerging research'
            state='new'
            size='sm'
            className={styles.tag}
          />
        </div>
        <Typography variant='body-s' color='grey'>
          See how your microbiome signature associates with risk of certain
          conditions.
        </Typography>
      </div>
      <div className={styles.cards}>
        {markers.map(marker => (
          <ConditionLinkCard
            key={marker.id}
            name={marker.display_title}
            // Absolute: marker detail is a sibling of `metrics`, not a child of it.
            href={`/results/${currentKitId}/conditions/${marker.id}`}
          >
            <StatusPill
              status={conditionEvaluationLabel(marker.evaluation)}
              color={conditionEvaluationColor(marker.evaluation_meaning)}
              iconName={
                conditionEvaluationIcon(marker.evaluation_meaning) ?? undefined
              }
            />
          </ConditionLinkCard>
        ))}
      </div>
    </div>
  );
}
